"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n    min-height: 1px;\n    box-shadow: 0px 1px 0px 0px #dedfe2;\n    height: 0.25rem;\n    margin-bottom: 0.25rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 5.25rem;\n    background-color: #f4f5f6;\n\n    svg {\n        height: 1.25rem;\n        margin-bottom: 0.5rem;\n\n        &.fire-svg {\n            height: 2.5rem;\n            path {\n                animation: smoke 1s linear infinite;\n            }\n        }\n    }\n\n    button {\n        color: #3963fe;\n        background: transparent;\n        font-size: 0.75rem;\n        font-weight: bold;\n        height: 1rem;\n        letter-spacing: 0.5px;\n        line-height: 1rem;\n        outline: none;\n        border: none;\n        padding: 0;\n        cursor: pointer;\n\n        &:hover {\n            opacity: 0.9;\n        }\n    }\n\n    @keyframes smoke {\n        0% {\n            opacity: 1;\n        }\n        50% {\n            opacity: 0.7;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    display: flex;\n    margin: 0.25rem 0;\n\n    &:last-child {\n        box-shadow: none;\n    }\n\n    img {\n        height: 3rem;\n        width: 3rem;\n        object-fit: contain;\n        margin: 0 0.5rem 0 0;\n    }\n\n    .item-details-container {\n        width: 100%;\n\n        p.item-part-name {\n            display: -webkit-box;\n            -webkit-line-clamp: 3;\n            -webkit-box-orient: vertical;\n            font-size: 0.75rem;\n            letter-spacing: 0.25px;\n            line-height: 1rem;\n            height: 3rem;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            text-align: left;\n            margin-bottom: 0.25rem;\n\n            b {\n                text-transform: capitalize;\n            }\n        }\n        .item-qty-price {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n\n            .item-qty-container {\n                display: flex;\n                align-items: center;\n\n                svg {\n                    height: 1rem;\n                    width: 1rem;\n                    color: #969ba5;\n                    cursor: pointer;\n                }\n\n                input {\n                    text-align: center;\n                    background: #fafafa;\n                    border-radius: 0.325rem;\n                    border: 1px solid #dedfe2;\n                    height: 1.75rem;\n                    width: 2.25rem;\n                    margin: 0 0.25rem;\n                    font-family: Lato;\n                    font-size: 0.75rem;\n                    color: #3e4148;\n\n                    &::-webkit-outer-spin-button,\n                    &::-webkit-inner-spin-button {\n                        -webkit-appearance: none;\n                    }\n\n                    &[type='number'] {\n                        -moz-appearance: textfield;\n                    }\n\n                    &:focus {\n                        outline: none;\n                        border: 1px solid #3963fe;\n                        box-shadow: 0px 0px 4px 0px #3963fe;\n                    }\n                }\n            }\n\n            .item-price-container {\n                display: flex;\n                align-items: center;\n\n                img {\n                    height: 1rem;\n                    width: 1rem;\n                    object-fit: contain;\n                    border-radius: 0.25rem;\n                    margin-left: 0.25rem;\n                }\n            }\n        }\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    /* width: 100%; */\n    padding: 0.75rem;\n\n    .collapse {\n        height: 0;\n        margin: 0;\n        background-color: #ffffff;\n        transition: height 0.5s, margin 0.5s, background-color 0.5s;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const ContainerStyle = _styledComponents.default.div(_templateObject());

const ItemRow = _styledComponents.default.div(_templateObject2());

const UndoContainer = _styledComponents.default.div(_templateObject3());

const Line = _styledComponents.default.div(_templateObject4());

var _default = {
  ContainerStyle,
  ItemRow,
  UndoContainer,
  Line
};
exports.default = _default;